import { useEffect } from 'react';
import {
  IParentAccountsResponse,
  ISearchResults,
  useSearchParentAccountsByDinerId,
} from 'src/utilities/useSearchHooks';

export type UseSearchParentAccountsByParentAdminReturn = {
  searchResults: ISearchResults<IParentAccountsResponse>;
};

export const useSearchParentAccountsByParentAdmin = (
  parentAdminId: string
): UseSearchParentAccountsByParentAdminReturn => {
  const searchResults = useSearchParentAccountsByDinerId(parentAdminId);

  useEffect(() => {
    searchResults.doSearch();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return { searchResults };
};
